const breakpoints = {
  maxres: "1025px",
  sd: "769px",
  hq: "481px"
};

function makeIframe(id) {
  const src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
  const iframe = document.createElement("iframe");

  iframe.setAttribute("allowfullscreen", "");
  iframe.setAttribute("frameborder", 0);
  iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
  iframe.src = src;
  iframe.width = 600;
  iframe.height = 337;

  return iframe;
}

function swapInIframe(e) {
  const { target } = e;
  const iframe = makeIframe(target.dataset.id);

  target.parentNode.replaceChild(iframe, target);
}

function makePlayButton(id) {
  const div = document.createElement("div");

  div.classList.add("video__play");
  div.dataset.id = id;
  div.addEventListener("click", swapInIframe);

  return div;
}

function makeThumbnailImage(id, title) {
  const imageUrlBase = `https://i.ytimg.com/vi/${id}`;
  const picture = document.createElement("picture");

  Object.keys(breakpoints).forEach(key => {
    const source = document.createElement("source");

    source.media = `(min-width: ${breakpoints[key]})`;
    source.srcset = `${imageUrlBase}/${key}default.jpg`;

    picture.appendChild(source);
  });

  const image = document.createElement("img");

  image.alt = title;
  image.src = `${imageUrlBase}/mqdefault.jpg`;

  picture.appendChild(image);

  return picture;
}

function addChildElements(video) {
  const { id, title } = video.dataset;

  video.appendChild(makeThumbnailImage(id, title));
  video.appendChild(makePlayButton(id));
}

function embedYoutube() {
  Array.from(document.querySelectorAll(".js-video[data-id]")).forEach(video => {
    addChildElements(video);
    video.classList.remove("js-video");
    delete video.dataset.id;
  });
}

export default embedYoutube;



// WEBPACK FOOTER //
// ./components/video.js